import { NewPriceStepText } from "./types";

export const NEW_PRICE_BASIC_STEP = 0;
export const NEW_PRICE_DETAILS_STEP = 1;
export const NEW_PRICE_EQUIPMENT_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const NEW_PRICE_INTRO_TEXTS: Record<number, NewPriceStepText> = {
  [NEW_PRICE_BASIC_STEP]: {
    title: "Izračunajte cijenu novog vozila",
    description: "Odaberite vozilo iz kataloga ili ga pronađite po JOM broju. Osnovna cijena dolazi iz podataka CVH.",
  },
  [NEW_PRICE_DETAILS_STEP]: {
    title: "Podaci za poreze i davanja",
    description: "Emisija CO2, snaga i obujam motora određuju PPMV. Označite i odbitak PDV-a ako ga koristite.",
  },
  [NEW_PRICE_EQUIPMENT_STEP]: {
    title: "Dodajte opremu vozila",
    description: "Uključena oprema već je označena. Dodajte ostalu opremu koju vozilo ima, pa je cijena točnija.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const NEW_PRICE_INTRO_SAMPLE = {
  jom: "JOM 104 223",
  co2: 128,
  enginePower: 110,
  engineDisplacement: 1968,
  numberOfSeats: 5,
  vatRate: 25,
  basePrice: 32400,
  equipment: [
    { name: "Navigacijski sustav", price: 850 },
    { name: "Grijanje sjedala", price: 420 },
    { name: "Parkirni senzori", price: 380 },
  ],
};
